<template>
    <pre v-if="config">
      {{ JSON.parse(config) }}
    </pre>

    <div v-else style="height: 100%" >
      <div class="spinner">
        <scale-loader />
      </div>
    </div>
</template>
<script>

export default {
  props: ['config'],
}

</script>

<style lang='scss' scoped>
  pre{
    max-height: 500px;
    text-align: initial;
  }

</style>
